import type { Ref } from 'react';
import React, { forwardRef, useCallback, useEffect } from 'react';
import type { Text } from 'react-native';
import { StyleSheet } from 'react-native';
import { useLayout } from 'react-native-web-hooks';

import { COLORS } from '@garnish/constants';
import type { TabNavTextProps } from '../TabNav.types';
import { BodyText } from '../../Text';

export const TabText = forwardRef((props: TabNavTextProps, ref: Ref<Text>) => {
  const { children, active, onChangeMeasures } = props;
  const { onLayout, width, height, x, y } = useLayout();

  useEffect(() => {
    if (onChangeMeasures) {
      onChangeMeasures({ width, height, x, y });
    }
  }, [width, height, x, y, onChangeMeasures]);

  const style = React.useMemo(
    () => [{ fontSize: 17 }, active ? styles.active : styles.inactive],
    [active],
  );

  const handleLayout = useCallback(
    (...args) => {
      onLayout(...args);
    },
    [onLayout],
  );

  return (
    <BodyText onLayout={handleLayout} ref={ref} style={style}>
      {children}
    </BodyText>
  );
});

const styles = StyleSheet.create({
  active: { color: COLORS.GREEN_2 },
  inactive: { color: COLORS.OPACITY.GREEN_1.DARKER },
});
